import { MouseEvent, ReactElement } from "react";
import { createPortal } from "react-dom";

import { CloseSVG } from "../../assets";
import { usePortal } from "../../hooks/UI";
import "./Modal.scss";

interface Props {
  id: string;
  children: ReactElement | ReactElement[];
  onCloseClick: () => void;
  type?: "warning" | "error" | "success";
  showCloseButton?: boolean;
  className?: string;
}

export const Modal = ({
  id,
  children,
  onCloseClick,
  type = "success",
  showCloseButton = false,
  className,
}: Props) => {
  const target = usePortal(id);

  const onBackdropClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (e.target === e.currentTarget) {
      onCloseClick();
    }
  };

  return createPortal(
    <div
      className={`modal modal--type-${type} ${className || ""}`}
      onClick={onBackdropClick}
    >
      <div className="modal__body">
        {showCloseButton && (
          <CloseSVG className="modal__close" onClick={onCloseClick} />
        )}
        {children}
      </div>
    </div>,
    target,
  );
};
